/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable, inject }                               from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { PcmsHubAdultIntakeCheckpoint } from '../model/pcms-hub-adult-intake-checkpoint';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { DateTime } from "luxon";



@Injectable({
  providedIn: 'root'
})
export class PcmsHubAdultIntakeCheckpointControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;
    protected httpClient = inject(HttpClient);
    private readonly injectedBasePath = inject(BASE_PATH, { optional: true });
    private readonly injectedConfiguration = inject(Configuration, { optional: true });

    constructor() {
        let basePath = this.injectedBasePath;
        const configuration = this.injectedConfiguration;
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (
          typeof value === 'object' &&
          !(value instanceof Date) &&
          !DateTime.isDateTime(value)
        ) {
          httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
          httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

   private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
     if (value == null) {
       return httpParams;
     }

     if (typeof value === "object" && value !== null) {
       if (Array.isArray(value)) {
         (value as any[]).forEach(elem => {
           httpParams = this.addToHttpParamsRecursive(httpParams, elem, key);
         });
       } else if (value instanceof Date) {
         if (key != null) {
           httpParams = httpParams.append(
             key,
             (value as Date).toISOString().substring(0, 10)
           );
         } else {
           throw Error("key may not be null if value is Date");
         }
       } else if (DateTime.isDateTime(value)) {
         if (key != null) {
           httpParams = httpParams.append(
             key,
             (value as DateTime).toISODate()
           );
         } else {
           throw Error("key may not be null if value is Luxon DateTime");
         }
       } else {
         Object.keys(value as any).forEach(k => {
           httpParams = this.addToHttpParamsRecursive(
             httpParams,
             (value as any)[k],
             key != null
               ? `${key}.${k}`
               : k
           );
         });
       }
     } else if (key != null) {
       // primitive / non-object
       httpParams = httpParams.append(key, String(value));
     } else {
       throw Error("key may not be null if value is not object or array");
     }
     return httpParams;
   }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public get1(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PcmsHubAdultIntakeCheckpoint>;
    public get1(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PcmsHubAdultIntakeCheckpoint>>;
    public get1(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PcmsHubAdultIntakeCheckpoint>>;
    public get1(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/integrations/pcms-hub/v1/compas/adult-intake/checkpoint`;
        return this.httpClient.request<PcmsHubAdultIntakeCheckpoint>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param pcmsHubAdultIntakeCheckpoint 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public put(pcmsHubAdultIntakeCheckpoint: PcmsHubAdultIntakeCheckpoint, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PcmsHubAdultIntakeCheckpoint>;
    public put(pcmsHubAdultIntakeCheckpoint: PcmsHubAdultIntakeCheckpoint, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PcmsHubAdultIntakeCheckpoint>>;
    public put(pcmsHubAdultIntakeCheckpoint: PcmsHubAdultIntakeCheckpoint, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PcmsHubAdultIntakeCheckpoint>>;
    public put(pcmsHubAdultIntakeCheckpoint: PcmsHubAdultIntakeCheckpoint, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (pcmsHubAdultIntakeCheckpoint === null || pcmsHubAdultIntakeCheckpoint === undefined) {
            throw new Error('Required parameter pcmsHubAdultIntakeCheckpoint was null or undefined when calling put.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/integrations/pcms-hub/v1/compas/adult-intake/checkpoint`;
        return this.httpClient.request<PcmsHubAdultIntakeCheckpoint>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: pcmsHubAdultIntakeCheckpoint,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
